<template>
  <h-list-page class="add-notice-container">
    <div class="notice-btn-group">
      <div class="reset-btn" @click="handleCancel">{{ h_i18n('625fb26b4b3340f7872b411f401e754c') }}</div>
    </div>
    <div style="width:630px;margin: 0 auto;">
        <div class="item-content">
          <div class="item-label">{{ h_i18n('32c65d8d7431e76029678ec7bb73a5ab') }}<span class="icon-style">*</span></div>
          <el-input v-model="addObj.title" maxlength="50" :placeholder="h_i18n('96641a78cfd9f9f8ba68f0524347b186')" disabled/>
        </div>
        <div class="item-content">
          <div class="item-label">{{ h_i18n('f1bd8b053770a696fc8646ca911c9520') }}<span class="icon-style">*</span></div>
          <el-select v-model="addObj.noticeType" :placeholder="h_i18n('1be9b0e068cdce00eb5f9c9634268cc9')" disabled>
            <el-option :label="h_i18n('1432c7fcdba00f248023082857b52281')" value="1" />
            <el-option :label="h_i18n('20faa88f0d2f0ab5f771e88deb352132')" value="2" />
            <!-- <el-option label="流程文件" value="3" /> -->
            <el-option :label="h_i18n('50d52dd929a75bb9b0f4afb0b7d879e1')" value="4" />
          </el-select>
        </div>
        <div class="item-content">
          <div class="item-label">{{ h_i18n('5ad2f695c4da24b49ba8a77a2bb01c5c') }}<span class="icon-style">*</span></div>
          <el-select v-model="addObj.visibleType" :placeholder="h_i18n('94499db3a370bf600e4faead59ae31fe')" disabled>
            <el-option :label="h_i18n('0d7942407f51e1b3cb2e995a80ca4098')" :value="0" />
            <el-option :label="h_i18n('b15edc81a94344441dd027c72358d605')" :value="1" />
            <el-option :label="h_i18n('7acc1680a5f6ee408eae017701ce7ccf')" :value="2" />
          </el-select>
        </div>
        <div class="item-content">
          <div class="item-label">{{ h_i18n('5fb17cfefdae401de0acbc52bf309042') }}<span class="icon-style">*</span></div>
          <el-date-picker v-model="addObj.uploadTime" type="datetime" :placeholder="h_i18n('61b7c646a1d32f102fe2a4993eda92e9')" formate="YYYY-MM-DD" class="myDate" style="width: 100%" disabled></el-date-picker>
        </div>
        <!-- <div class="item-content">
          <div class="item-label">有效期<span class="icon-style">*</span></div>
          <el-date-picker v-model="addObj.expirationDate" type="datetime" placeholder="请选择有效期" format="YYYY-MM-DD HH:mm:ss" class="myDate" style="width: 100%" disabled/>
        </div> -->
        <!--<div class="item-content">
          <div class="item-label">是否发布<span class="icon-style">*</span></div>
          <el-radio-group v-model="addObj.isPublish" disabled>
            <el-radio value="0" size="large" label="0">否</el-radio>
            <el-radio value="1" size="large" label="1">是</el-radio>
          </el-radio-group>
        </div>-->
        <div class="item-content">
          <div class="item-label">{{ h_i18n('a6fc9e3ae6f4333a43ffc1774a0b4347') }}<span class="icon-style">*</span></div>
          <div class="item-file" @click="handleDownLoad(addObj.fileUuid,addObj.fileName)">{{ addObj.fileName }}</div>
        </div>
        <div class="item-content">
          <div class="item-label">{{ h_i18n('3bdd08adab6ea90b9164b20a0e4151ac') }}</div>
          <div style="min-height: 300px;" class="detailnoticeContent" v-html="addObj.noticeContent">
           
          </div>
        </div>
        
    </div>
  </h-list-page>
</template>
<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

export default {
  data(){
    return{
      addObj:{
        title:''
      },
      fileObj:{},
      rules:[]
    }
  },
  methods:{
    h_i18n,
    handleDownLoad(fileUuid,fileName){
      if(fileUuid == ""||fileUuid == undefined ||fileUuid == null){
        this.info(h_i18n('e334e916fdda30d81fe74a8cdeb97d65'));
        return false;
      }
      this.$http({
        method: "get",
        url: `/base/fileDownload/downLoadFileFtp?type=9&filePath=${fileUuid}`,
        responseType: "blob",
      }).then((res) => {
        console.log('res=====',res)
        if (res.status == 200) {
          let suffix = fileName.substring(fileName.lastIndexOf('.'))
          // let blob = BlobType(suffix,res.data); // 文件流
          let blobUrl = URL.createObjectURL(res.data);
          const link = document.createElement("a"); //模拟a链接，不支持低版本ie
          link.download = fileName;
          link.style.display = "none";
          link.href = blobUrl;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }else{
          this.info(res.message)
        }
      });
    },
    handleCancel(){
      this.addObj = {}
      this.$router.push({
        name:'SystemNotice',
        query:{
          ...this.$route.query
        }
      })
    },
    getNoticeById(){
      this.$http({
        method: "get",
        url: `/base/notice/getInfoById?noticeId=${this.$route.query.id}`,
      }).then((res) => {
        if(res.data.code==0){
          this.$nextTick(()=>{
            console.log('res.data.data',res.data.data)
            
            this.addObj = {...res.data.data}
            console.log('this.addObj',this.addObj)
            // editor.txt.html(res.data.data.noticeContent)
            this.addObj.isPublish = String(res.data.data.isPublish)
            this.addObj.name = res.data.data.fileName
            this.fileObj.fileName = res.data.data.fileName
            this.fileObj.fileUuid = res.data.data.fileUuid
            this.fileObj.name = res.data.data.fileName
            this.addObj.noticeType = String(this.addObj.noticeType)
          })
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getNoticeResource(){
      this.$http({
        method: "get",
        url: `/base/noticeResource/queryNoticeResourceByNoticeId?noticeId=${this.$route.query.id}`,
      }).then((res) => {
        if(res.data.code==0){
          console.log('5353534',res)
        }
      }).catch(err=>{
        console.log(err)
      })
    }
  },
  mounted(){
    if(this.$route.query.id){
      this.getNoticeById()
    }
    this.getNoticeResource()
  }
}
</script>

<style>
.is-hwork .el-input__prefix{
  padding-left: 8px !important;
}
.el-input__icon{
  line-height: 34px !important;
}
</style>

<style lang="scss" scoped>

.add-notice-container{
  background: #fff;
  .item-content{
    margin: 12px 0;
    .item-label{
      color: #4E5969;
      font-size: 14px;
      margin-bottom: 8px;
      .icon-style{
        position: relative;
        color: red;
        top: 2px;
        left: 5px;
      }
    }
  }
  .item-file{
    color: #165dff;
    cursor: pointer;
  }
}

// .myDate :deep(.el-input__icon){
//   padding-left: 8px !important;
//   line-height:32px !important;
// }
// .myDate :deep(.el-icon-time){
//   padding-left: 8px !important;
// }
// .myDate{
//   .el-input__prefix{
//     padding-left: 8px !important;
//   }
// }
.notice-btn-group{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.primary-btn{
  min-width: 60px;
  max-width: 80px;
  height: 30px !important;
  line-height: 30px !important;
  text-align: center;
  background: #fff;
  border: 1px	solid#165DFF;
  color: #165dff;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.reset-btn{
  width: 60px;
  height: 30px !important;
  line-height: 30px !important;
  text-align: center;
  background: #fff;
  border: 1px	solid#C9CDD4;
  color: #1D2129;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}
.marginL12{
  margin-left: 12px;
}
// .is-hwork .el-input__prefix{
//   padding-left: 8px !important;
// }
// .el-input__icon{
//   line-height: 32px !important;
// }
.detailnoticeContent {
  box-sizing: border-box;
  width: 630px;
  background-color: #F5F7FA;
  border: 1px solid#E4E7ED;
  color: #C0C4CC;
  cursor: not-allowed;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
  padding: 0 16px;
  table {
    border: 1px solid #ddd;
    tbody {
      border: 1px solid #ddd;
      tr {
        border: 1px solid #ddd;
        th {
          border: 1px solid #ddd;
        }
        td {
          border: 1px solid #ddd;
        }
      } 
    }
  }
} 
</style>